import React from 'react';

import { getTitleLocationStatesMapFileUrl } from '../../../services/mediaBucketS3Service';
import { WIDGET_NAMES } from '../../../utils/constant';

import StatesCountyMap from './index';

import classes from './index.module.css';

const TitleLocationStatesMap = (props) => {
  const { title, jobTitlePlural } = props;
  const svgFileUrl = getTitleLocationStatesMapFileUrl(title);

  const gtmEventNames = {
    open: 'Title Location Heatmap Modal Open',
  };
  const mapTooltip = {
    title: `Number of ${jobTitlePlural}`,
    valueFormatFunc: (value) => value || 0,
  };
  const legendTooltip = {
    title: `Number of ${jobTitlePlural}`,
    valueFormatFunc: (range, isLast) => {
      const rangeArr = range.split('-') || [];
      if (!rangeArr || !rangeArr.length) {
        return '';
      }
      return `${rangeArr[0]} - ${rangeArr[1]}${isLast ? '+' : ''}`;
    },
  };
  const legendLabelsCallback = (legendItems) => {
    if (!legendItems || !legendItems.length || !legendItems[0].rangeDisplay) {
      return <></>;
    }

    const minValue = legendItems[0].rangeDisplay.split('-')[0];
    const maxValue = legendItems[legendItems.length - 1].rangeDisplay.split('-')[1];

    return (
      <>
        <span className={classes['legend-label-part']}>
          <span className={classes['county-value']}>{minValue}</span>
          <span>Lowest</span>
        </span>
        <span className={classes['legend-label-part']}>
          <span>Highest</span>
          <span className={classes['county-value']}>{maxValue}</span>
        </span>
      </>
    );
  };

  return (
    <StatesCountyMap
      {...props}
      svgFileUrl={svgFileUrl}
      gtmEventNames={gtmEventNames}
      embedWidgetType={WIDGET_NAMES.TITLE_LOCATION_STATES_MAP}
      mapTooltip={mapTooltip}
      legendTooltip={legendTooltip}
      legendLabelsCallback={legendLabelsCallback}
    />
  );
};

export default TitleLocationStatesMap;
